const MANUAL_LOGOUT_KEY = "epic_jobs_manual_logout";

const storage = () => {
  try {
    return window.sessionStorage;
  } catch (error) {
    return null;
  }
};

export const markManualLogout = () => {
  storage()?.setItem(MANUAL_LOGOUT_KEY, "1");
};

export const isManualLogout = () => {
  return storage()?.getItem(MANUAL_LOGOUT_KEY) === "1";
};

export const consumeManualLogout = () => {
  storage()?.removeItem(MANUAL_LOGOUT_KEY);
};

export const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user") || "null");
  } catch (error) {
    return null;
  }
};

export const getAuth = () => {
  const token = localStorage.getItem("token");
  const user = getStoredUser();

  return { token, user, isLoggedIn: Boolean(token && user) };
};

export const getDashboardPath = (user) => {
  if (user?.role === "employer") return "/employee-dashboard";
  if (user?.role === "seeker") return "/candidate-dashboard";
  if (user?.role === "admin") return "/admin-dashboard";

  return "/";
};

export const getLoginPath = (from) => {
  if (isManualLogout()) return "/login";

  return from ? `/login?redirect=${encodeURIComponent(from)}` : "/login";
};

const normalizePath = (path) => (typeof path === "string" ? path : "");

export const getRouteRole = (path = "") => {
  const safePath = normalizePath(path);

  if (safePath.startsWith("/admin-")) return "admin";
  if (safePath.startsWith("/employee-") || safePath.startsWith("/payment-") || safePath === "/invoice") return "employer";
  if (safePath.startsWith("/candidate-") || (safePath.startsWith("/jobs/") && safePath.endsWith("/apply"))) return "seeker";

  return null;
};

export const getSafeRedirectPath = (redirect, user) => {
  const safeRedirect = normalizePath(redirect);

  if (!safeRedirect || !safeRedirect.startsWith("/") || safeRedirect.startsWith("//")) {
    return getDashboardPath(user);
  }

  const routeRole = getRouteRole(safeRedirect);

  if (routeRole && routeRole !== user?.role) {
    return getDashboardPath(user);
  }

  return safeRedirect;
};

export const isAllowedRole = (user, roles) => {
  if (!roles) return true;

  const allowedRoles = Array.isArray(roles) ? roles : [roles];

  return allowedRoles.includes(user?.role);
};

export const setAuth = (token, user) => {
  localStorage.setItem("token", token);
  localStorage.setItem("user", JSON.stringify(user));
  notifyAuthChanged();
};

export const refreshStoredUser = (user) => {
  localStorage.setItem("user", JSON.stringify(user));
  notifyAuthChanged();
};

export const clearAuth = ({ notify = true } = {}) => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");

  if (notify) {
    notifyAuthChanged();
  }
};

export const notifyAuthChanged = () => {
  window.dispatchEvent(new Event("auth-change"));
};

export const clearDashboardBodyClasses = () => {
  if (typeof document === "undefined") return;

  document.body.classList.remove(
    "admin-dashboard-active",
    "admin-sidebar-visible",
    "candidate-dashboard-active",
    "candidate-sidebar-visible",
    "employee-dashboard-active",
    "employee-sidebar-visible",
    "mobile-menu-visible"
  );
};

export const logoutUser = async ({ notify = true } = {}) => {
  markManualLogout();
  clearDashboardBodyClasses();

  const token = localStorage.getItem("token");

  if (token) {
    await fetch(process.env.REACT_APP_BASE_API_URL + "/logout", {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Authorization": "Bearer " + token,
      },
    }).catch(() => null);
  }

  clearAuth({ notify });
  clearDashboardBodyClasses();
};
